"use client";

import { Suspense, useEffect, useRef, useState } from "react";

import { Sidebar } from "./sidebar";
import { ShellGate, ShellProvider } from "./shell-context";

const SIDEBAR_ID = "hauptnavigation";

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <ShellProvider>
      <Chrome>{children}</Chrome>
    </ShellProvider>
  );
}

function Chrome({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const menuButton = useRef<HTMLButtonElement>(null);

  // Escape schließt den Drawer und gibt den Fokus an den Menü-Button zurück
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      setOpen(false);
      menuButton.current?.focus();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <div className="min-h-screen lg:flex">
      <a
        href="#inhalt"
        className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded-md focus:bg-white focus:px-4 focus:py-3 focus:text-sm focus:text-ink"
      >
        Zum Inhalt springen
      </a>

      <header className="sticky top-0 z-30 flex items-center gap-3 bg-nav px-4 py-2 lg:hidden">
        <button
          ref={menuButton}
          type="button"
          aria-expanded={open}
          aria-controls={SIDEBAR_ID}
          onClick={() => setOpen((current) => !current)}
          className="h-11 rounded-md border border-nav-line bg-nav-raised px-3 text-sm text-white"
        >
          {open ? "Menü schließen" : "Menü"}
        </button>
        <span className="text-[17px] font-semibold tracking-tight text-white">GEO Suite</span>
      </header>

      {open && (
        <button
          type="button"
          aria-label="Menü schließen"
          tabIndex={-1}
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
        />
      )}
      {/* usePathname() liest URL-Daten: bei dynamischen Routen (z. B. /briefing/[id]) braucht das eine Suspense-Grenze */}
      <Suspense fallback={<div className="hidden bg-nav lg:block lg:w-[248px] lg:shrink-0" />}>
        <Sidebar id={SIDEBAR_ID} open={open} onNavigate={() => setOpen(false)} />
      </Suspense>

      <main id="inhalt" tabIndex={-1} className="min-w-0 flex-1">
        <ShellGate>{children}</ShellGate>
      </main>
    </div>
  );
}
